import { registerLazyI18nextInstance } from "@packages/core-client/i18n/registerLazyI18nextInstance.ts";
import type { FireflyRuntime } from "@squide/firefly";

export const i18NextInstanceKey = "team-module";

export function initI18next(runtime: FireflyRuntime) {
    return registerLazyI18nextInstance(runtime, i18NextInstanceKey, {
        "en-US": async () => (await import("./en.ts")).en,
        "fr-CA": async () => (await import("./fr.ts")).fr
    });
}
